export enum TaskTypes {
  WATCH_VIDEO = 'watch-video',
  OPERATIONAL = 'operation',
  GOVERNANCE = 'governance',
}

export default TaskTypes
